/**
 * Firebase Client - Adaptador completo para reemplazar Base44 SDK
 * 
 * Este módulo proporciona una API compatible con Base44 pero usando Firebase.
 * Permite migrar componentes gradualmente sin reescribir toda la lógica.
 * 
 * Uso:
 * 
 * Antes (Base44):
 *   import { base44 } from '@/api/base44Client';
 *   const leads = await base44.entities.Lead.list();
 *   const user = await base44.auth.me();
 *   await base44.functions.invoke('myFunction', { data });
 * 
 * Después (Firebase):
 *   import { firebase } from '@/api/firebaseAdapter';
 *   const leads = await firebase.entities.Lead.list();
 *   const user = await firebase.auth.me();
 *   await firebase.functions.invoke('myFunction', { data });
 */

import { entities } from './firestoreHelpers';
import { authHelper } from './authHelper';
import { functionsHelper } from './functionsHelper';

// Crear objeto similar a base44
export const firebase = {
  entities,
  auth: authHelper,
  functions: functionsHelper
};

// También exportar como base44 para compatibilidad durante la migración
export const base44 = firebase;

export default firebase;
